
import Resizer from "react-image-file-resizer"
import { identificarDispositivoNativo } from "./dispositivo.js"
import { isIOS } from "./config/nativeBridge.js"

//const maxSize = 2048
const maxSize = 1536

export async function reduceImage(image) {
	if (image) {
		const canvas = document.createElement("canvas"),
			oriWidth = image.width,
			oriHeight = image.height

		let newWidth, newHeight

		if (oriWidth > oriHeight) {
			newWidth = maxSize
			newHeight = (oriHeight / oriWidth) * maxSize
		} else {
			newHeight = maxSize
			newWidth = (oriWidth / oriHeight) * maxSize
		}

		canvas.width = newWidth
		canvas.height = newHeight

		const ctx = canvas.getContext("2d")
		ctx.drawImage(image, 0, 0, newWidth, newHeight)
		//        return "data:image/jpg;base64," + canvas.toDataURL("image/jpeg", 0.6).split(",")[1]
		return "data:image/jpg;base64," + canvas.toDataURL("image/jpeg", 0.5).split(",")[1]
	}
}

export const resizePic = async file => {
	let base_image = await returnSizeMedia(file)
	let tamanhos = getMediaSize(base_image.w, base_image.h, 512, 512)

	return new Promise((resolve) => {
		Resizer.imageFileResizer(
			file,
			tamanhos.width,
			tamanhos.height,
			"png",
			5,
			0,
			(uri) => {
				resolve(uri);
			},
			"file"
		)
	})
}

export const getMediaSize = (iw, ih, mw, mh) => {
	let widthPercent = mw / iw;
	let heightPercent = mh / ih;
	let smallestPercent = Math.min(widthPercent, heightPercent);

	return {
		width: parseInt(iw * smallestPercent),
		height: parseInt(ih * smallestPercent),
	}
}

export const returnSizeMedia = (file) => {
	return new Promise(res => {
		let reader = new FileReader()

		reader.readAsDataURL(file)
		reader.onload = function (e) {
			let image = new Image()

			image.src = e.target.result
			image.onload = function () {
				res({
					w: this.width,
					h: this.height,
				})
			}
		}
	})
}

export const verificarFakeGPS = () => {
	try {
		if (window.AndroidInterface)
			return window.AndroidInterface.isFakeGPS()
	} catch {
		return false
	}
}

export const verificarBootClick = async () => {
	try {
		if (!!window.AndroidInterface) {
			const retorno = await window.AndroidInterface.isAccessibilityActive();
			return retorno === true;
		}
	} catch {

	}
	//console.log('verificarBootClick ==> ', retorno)
	return false

}

export function copy(content) {	
	if (window?.AndroidInterface && typeof window.AndroidInterface?.copyTextToClipboard != "undefined")
		window.AndroidInterface?.copyTextToClipboard(content)
	else navigator.clipboard?.writeText(content)
		.then(() => print("copiado")).catch((err) => {
			if (err?.stack) {
				if (err.stack.includes("Write permission"))
					print("Sem permissão para copiar!")
				else if (err.stack.includes("Document is not focused"))
					print("Tela não estava em foco!")
				else
					print("Houve um problema, lamentamos!")
			} else print("Falha ao tentar copiar.")
		}) ?? print("Não foi possível copiar, atualize seu aplicativo!")
}

export function print(msg) {
	if (window?.AndroidInterface)
		window.AndroidInterface.showAndroidVersion(msg)
	else
		alert(msg)
}

/** Abre URL no navegador externo (Safari, Chrome etc.), inclusive no app nativo. */
export function abrirLinkNoNavegador(url) {
	if (!url || typeof window === "undefined") return

	try {
		if (typeof window.AndroidInterface?.redirectLink === "function") {
			window.AndroidInterface.redirectLink(url)
			return
		}
	} catch (err) {
		console.error("[abrirLinkNoNavegador] redirectLink:", err)
	}

	const dispositivo = identificarDispositivoNativo()
	const celularUa = /Android|webOS|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent || "")
	const celular = !!dispositivo || celularUa

	if (!celular) {
		window.open(url, "_blank", "noopener,noreferrer")
		return
	}

	// iOS WebView: window.open dispara abertura no Safari via WKUIDelegate
	if (dispositivo === "iOS" || isIOS()) {
		window.open(url, "_blank", "noopener,noreferrer")
		return
	}

	// Android WebView sem redirectLink: intent abre o navegador padrão
	if (dispositivo === "Android") {
		try {
			const parsed = new URL(url)
			const path = `${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`
			const scheme = parsed.protocol.replace(":", "")
			window.location.href = `intent://${path}#Intent;scheme=${scheme};action=android.intent.action.VIEW;end`
		} catch {
			window.location.assign(url)
		}
		return
	}

	// Celular no navegador (Chrome/Safari mobile)
	window.location.assign(url)
}
